// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderInnerOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderInnerOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderInnerOutlined = function BorderInnerOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderInnerOutlinedSvg
  }));
};

BorderInnerOutlined.displayName = 'BorderInnerOutlined';
export default React.forwardRef(BorderInnerOutlined);